import React from 'react';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { useProviderUrlsApi } from '../../operations/hooks';
import IngestionStatusChip from '../../shared/components/IngestionStatusChip';

const getCallIngestionStatus = (call) => {
    const httpStatus = call.metadata && call.metadata['http-status-code'];
    if (httpStatus) {
        const code = Number(httpStatus);
        return code >= 200 && code < 300 ? 'SUCCEEDED' : 'FAILED';
    }
    return call.hasData ? 'SUCCEEDED' : 'FAILED';
};

const ProviderUrlsTable = ({ operationId }) => {
    const [{ data, isLoading, isError }] = useProviderUrlsApi(operationId);

    if (isLoading) {
        return <div>Loading provider URLs...</div>;
    }

    if (isError || !data || !data.calls) {
        return null;
    }

    const callsWithUrls = data.calls
        .filter((call) => call.metadata && call.metadata['provider-url']);

    if (callsWithUrls.length === 0) {
        return null;
    }

    return (
        <Box>
            <Typography variant="h5">Provider URLs</Typography>
            <Divider />
            <TableContainer>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>URL</TableCell>
                            <TableCell>Status</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {callsWithUrls.map((call) => {
                            const url = call.metadata['provider-url'];
                            const status = getCallIngestionStatus(call);
                            return (
                                <TableRow key={url}>
                                    <TableCell>
                                        <Link href={url} target="_blank" rel="noreferrer">
                                            {url}
                                        </Link>
                                    </TableCell>
                                    <TableCell>
                                        <IngestionStatusChip status={status} />
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

const ProviderUrls = ({
    dataSourceStatus,
    dataSetConfigId
}) => {
    if (dataSourceStatus == null || dataSourceStatus.dataSetConfigs == null) {
        return null;
    }

    const statuses = dataSourceStatus.dataSetConfigs || [];
    const dataSetStatus = statuses.find(
        (status) => status.dataSetConfigId === Number(dataSetConfigId)
    );

    if (dataSetStatus == null || dataSetStatus.lastRunInfo == null) {
        return null;
    }

    return <ProviderUrlsTable operationId={dataSetStatus.lastRunInfo.operationId} />;
};

export default ProviderUrls;
